import React from 'react';
import { Link, TableCell, TableRow } from '@mui/material';
import { unityLoadersWithCompression } from '../../../../../../../common/domain/game';
import UnityCompressionSelect from './UnityCompressionSelect';
import { UploadedFile } from '../../../../../../../common/domain/upload';
import { StyledBodyText } from '../../../../../../../common/Styleguide/Common/Text';
import { COLORS } from '../../../../../../../common/Styleguide/Common/colors';
import UnityCompressionWarnings from './UnityCompressionWarnings';
import { UnityEncoding } from '@crazygames/game-types/src/game-build/unity-encoding.type';
import { GameLoaderType } from '@crazygames/game-types/src/game-build/loader.type';

export interface UnityCompressionOptionProps {
  gameLoaderType: GameLoaderType | null;
  unity56Encoding?: UnityEncoding;
  onChange: (newEncoding: UnityEncoding) => void;
  files: UploadedFile[] | null;
  isNonEditable?: boolean;
}

const UnityCompressionOption: React.FC<UnityCompressionOptionProps> = (props) => {
  const { gameLoaderType, unity56Encoding, onChange, isNonEditable } = props;

  if (!gameLoaderType || !unityLoadersWithCompression.includes(gameLoaderType)) {
    return null;
  }

  const instructionsLink = 'https://docs.unity3d.com/Manual/webgl-deploying.html';

  return (
    <TableRow>
      <TableCell>
        <StyledBodyText variant="h3">Compresion</StyledBodyText>
      </TableCell>
      <TableCell>
        <UnityCompressionSelect onChange={onChange} unity56Encoding={unity56Encoding} isNonEditable={isNonEditable} />
        {!isNonEditable && (
          <UnityCompressionWarnings gameLoaderType={gameLoaderType} files={props.files} unity56Encoding={unity56Encoding} />
        )}
        {!isNonEditable && (
          <StyledBodyText sx={{ m: 0 }} color="white30">
            Select the compression you used when exporting your game. You can find more information{' '}
            <Link href={instructionsLink} target="_blank" style={{ color: COLORS.brand[100] }}>
              here
            </Link>
            .
          </StyledBodyText>
        )}
      </TableCell>
    </TableRow>
  );
};

export default UnityCompressionOption;
